import styled, { css } from 'styled-components';
import { backgroundOptions } from '../../components/base/utils/utils';

export const backgroundImageStyles = css`
	height: 40rem;
	background-size: cover;
	background-position: 50% 50%;
`;

export const Cube = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: ${props => props.height || '30rem'};
	${backgroundOptions};
	color: #fff;
	font-size: 1.6rem;
`;
